import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "en",
};

const dictionarySlice = createSlice({
  name: "dictionary",
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = dictionarySlice.actions;
export default dictionarySlice.reducer;
